import styled from "styled-components";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";

export const RouterOutletCasino777Box = styled(RouterOutletDefaultBox)`
  background: ${props => `linear-gradient(${props.theme.colors.brandPrimaryDark}, ${props.theme.colors.brandSecondary}, ${props.theme.colors.brandPrimaryDark})`};
`